export default {
  languageChange(state, val) {
    let CreditsText = "";
    if (window.sessionStorage.getItem("MODULEDATA")) {
      CreditsText =
        JSON.parse(window.sessionStorage.getItem("MODULEDATA")).creditName ||
        "积分";
    }
    let companyName = "福粒";
    if (process.env.COMPANY_NAME == "fenghuo") {
      companyName = "臻效VIP";
    } else if (process.env.COMPANY_NAME == "mz") {
      companyName = "民置商城";
    }
    /***
         * 星展银行特殊处理
         * aon积分名称修改“iFlex积分” 英文“iFlex Credits”
           节日积分名称修改为员工俱乐部积分，英文“Club Credits”
        * ***/
    let aon = "弹性福粒";
    let festival = "节日";
    let ordinary = "普通";
    let iFlex = JSON.parse(sessionStorage.getItem("MODULEDATA"))
      ? JSON.parse(sessionStorage.getItem("MODULEDATA")).iFlex
      : "";
    if (iFlex) {
      aon = "弹性福粒";
      festival = "员工俱乐部";
      ordinary = "其他";
    }
    state.messageCn.message = {
      ordinary: ordinary,
      festival: festival,
      discounts2: "立省",
      price_range: "价格区间",
      purchase_notes: "购买须知",
      FrequentlyAskedQuestions_weini: "跨境商品常见问题",
      confirm_order_tip1:
        "由于地址信息调整的，请重新编辑当前收货地址中“所在区域”选项，即可顺利下单！",
      confirm_order_btn1: "去完善",
      FrequentlyAskedQuestions: "常见问题",
      FrequentlyAskedQuestions_weini: "跨境商品常见问题",
      weiNiInternational: "跨境海淘",
      integralBuckle: CreditsText + "可抵",
      paymentQuestion: "支付疑问",
      shipAddress: "发货地",
      paymentQuestionTitle1: "发货方式",
      paymentQuestionTitle2: "税费",
      containsFees: "包含税费",
      troubleShooting: "问题解答",
      paymentQuestionTitle3: "部分抵扣",
      paymentQuestionCon1:
        "跨境商品经由海外或保税仓发货，根据商品不同的情况，会分为不同关口保税仓发货。收货时效性也会不相同",
      paymentQuestionCon2: "购买海外商品需依法向中国海关申报及纳税",
      paymentQuestionCon3:
        "跨境商品由多种类供应商提供货物，其中货物部分由海外仓直接发货，根据中国海关申报条件。需要用户支付单、物流单、订单号信息（商品、支付金额等信息）必须通过海关申报。",
      paymentQuestionCon4:
        "如您遇到部分商品只能抵扣部分金额，给您带来不便请谅解！",
      pay_attention_to: "去关注",
      attention_tip1: "关注公众号购买商品再省",
      attention_tip2: "关注公众号",
      attention_tip3: "您已关注公众号",
      attention_tip4: "此订单可减免",
      attention_tip5: "取消关注将不再享受此优惠哦！",
      money_z: "元",
      focus_on_relief: "关注减免",
      has_been_cut: "已减免",
      attention_tip6: "购买商品省",
      attention_tip7: "购买商品预计省",
      attention_tip8: "微信扫描二维码关注公众号，本商品可立减",
      info_tip3: "·不支持7天无理由退换货 · 身份证核验 · 现金支付",
      shopCart01: "您选中的商品包含国际商品",
      shopCart02: "需要和其他商品分开结算",
      shopCart03: "跨境海淘",
      yourCart: "我的购物车",
      checkTheCart: "查看购物车",
      checkOrderInfo: "填写核对订单信息",
      placeTheOrder: "购买成功",
      selectAll: "全选",
      product: "商品信息",
      specification: "规格",
      price: "单价",
      quantity: "数量",
      ExtPrice: "总价",
      ExtPrice2: "小计",
      noGoods: "此地区无货",
      pleaseChoose: "请选择",
      state: "状态",
      stock: "库存",
      operation: "操作",
      delete: "删除",
      total: "总计",
      proceedToOrder: "结算",
      contactInfo: "联系人信息",
      addYourAddressFirst: "您还没有收货地址，请先添加",
      addAnAddress: "添加收货地址",
      Create_address:'创建收货地址',
      address:'地址',
      addressInfo:{
        Edit:'修改',
        Delete:'删除',
        Address:'收货地址',
        Name:'收货人',
        Phone:'联系电话',
        Default:'默认地址',
      },
      checkTheOrder: "确认订单信息",
      discounts: "优惠",
      points: CreditsText,
      YourCurrentPoint: "共",
      YourCurrentPoint2: companyName + "币",
      youCouldUse: "可抵扣",
      thisTime: "元",
      coupons: "优惠券",
      available: "张可用",
      noUsingOfCoupons: "不使用优惠券",
      delivery: "配送方式",
      freight: "运费",
      support: "支持",
      paymentMethod: "支付方式",
      youHaveToPay: "需要支付金额",
      orderInfo: "订单结算",
      productsPrice: "商品总价",
      freightPrice: "物流费用",
      discountsPrice: "促销优惠",
      proceedToOrder2: "提交订单",
      price2: CreditsText + "价",
      fuli: "售价",
      distributionTo: "配送至",
      inStock: "有货",
      oldpassword: "旧密码",
      newpassword: "新密码",
      repnewpassword: "重复新密码",
      outStock: "无货",
      pts: CreditsText,
      quantity2: "购买数量",
      addToCart: "加入购物车",
      productIsSoldOut: "商品缺货",
      productInfo: "商品详情",
      afterSalesService: "售后保障",
      hello: "您好",
      yourCurrentPo: "您现在的" + CreditsText + "为：",
      hdPoint: "点",
      yourOrders: "我的订单",
      approve: "认可激励",
      yourAccount: "我的账户",
      welcome: "欢迎",
      benefitModules: "福利模块",
      accountManagement: "账号管理",
      changePassword: "修改密码",
      changePassword2: "修改密码",
      NewPassword:'新密码',
      OldPassword:'旧密码',
      Re_NewPassword:'重复新密码',
      close: "关闭",
      changepaypassword: "修改支付密码",
      PaymentManagement: "支付管理",
      password: "支付密码：",

      customer: "会员权限",
      IntegralInfo: CreditsText + "信息",
      Ques: {
        OrderingGuide: "订购指南",
        MemberAccount: "会员账户",
        OrderMethods: "订购方式",
        PaymentTerms: "交易条款",
        ReturnsReplacements: "退/换货政策",
        CarrierInformation: "运费标准",
        PaymentDelivery: "支付配送",
        PaymentMethods: "支付方式",
        DeliveryTimes: "配送时间",
        DeliveryAreas: "配送范围",
        CheckSign: "签收验货",
        CustomerCenter: "顾客中心",
        TermsofUse: "使用条款",
        RulesofPoints: CreditsText + "规则",
        GuaranteePolicy: "三包政策",
        InformationProtection: "信息保护",
        AboutUs: "关于我们",
        Clients: "合作伙伴",
        LegalNotice: "法律公告",
        ContactUs: "联系我们"
      },
      fuliCo: companyName + "公司版权所有2013-2020",
      Screening: "筛选",
      PriceLow: "价格从低到高",
      PriceHigh: "价格从高到低",
      SaleLow: "销量从低到高",
      SaleHigh: "销量从高到低",
      NewArrival: "新品",
      Category: "商品目录",
      Help: "帮助中心",
      CompanyIntro: "公司介绍",
      specialRecommend: "特别推荐",
      PricesForCustom: "价格定制",
      Discounts: "精选特惠",
      Search: "搜索",
      LowPrice: "正品低价",
      WorryfreeAftersalesService: "无忧售后",
      QualityGuarantee: "品质保障",
      StandardCredits: ordinary + CreditsText,
      FestivalCredits: festival + CreditsText,
      aonCredits: "" + aon + "积分",
      No_detail:'合作平台无明细',
      aonCreditsNo: "" + aon + "积分无明细",
      aonCreditsText:"合作平台积分为对接的合作平台积分数据，实时消耗数据请登录合作平台进行查看！",
      creditsChane: "可选择" + CreditsText + "进行抵扣",
      fixNav: {
        Coupon: "优惠券",
        Cart: "购物车",
        Credits: CreditsText,
        Orders: "订单",
        QRCode: "二维码",
        applet: "小程序",
        Tencent: "公众号",
        scanQRCode: "扫描二维码",
        followthewechatofficialaccount: "关注公众号",
        onlinecustomerservice: "在线客服",
        onlinetime: "在线时间",
        customerservice: "客服",
        contactcustomerservice: "联系客服",
        callcenter: "客服热线",
        workingday: "工作日",
        yourID: "您的用户名/企业名",
        pleasefeedbacktothecustomerservicepeople: "反馈时告知客服哦",
        top: "顶部"
      },
      newaddress: "新增收货地址",
      newaddress2: "请完善收货地址，开启购物之旅",
      editAddress: "编辑收货地址",
      addressinformation: "地址信息",
      Townshipstreet: "乡镇街道",
      addressdetail: "详细地址",
      consigneename: "收货人姓名",
      phoneNo: "手机号码",
      identitycard: "身份证号码",
      defaultaddress: "设置为默认收货地址",
      Address_area: "地址区域",
      Overseas_address: "海外地址",
      Overseas_address_remark: "仅限境外配送商品",
      Chinese: "中文",
      English: "英文",
      save: "保存",
      cancel: "取消",
      confirm:'确定',
      More:'更多',
      suggest: {
        construction_content: "建议内容",
        suggested_type: "建议类型",
        status: "状态",
        see_feedback: "查看反馈",
        have_acccepted: "已受理",
        being_processed: "处理中",
        complaints_immediately: "立即投诉建议",
        reply_content: "回复内容",
        upload_pictures: "上传图片",
        suggest_tip1:
          "建议尺寸 350*120 只能上传jpg/png/bmp文件，且单个文件不超过3M",
        suggest_tip2: "您的每一个反馈，都是对我们的有力支持！感谢您的参与！",
        submissions: "提交内容",
        complaints_time: "投诉时间",
        complaint_category: "投诉类别",
        complaint_content: "投诉内容",
        documentary_evidence: "证明文件",
        advice_feedback: "建议反馈",
        suggest_tip3:
          "您的建议内容我们已经收到，相关问题和内容会在第一时间给你反映。感谢您的支持！",
        goBack: "返回"
      },
      MY: {
        myaccount: "我的主页",
        ordercenter: "订单中心",
        myorders: "我的订单",
        customercenter: "客户中心",
        complaint_advice: "投诉建议",
        mydiscountcoupon: "我的优惠券",
        myaftersalesservice: "我的售后",
        myElectronicCard: "我的卡密",
        accountcenter: "账户中心",
        mycredits: "我的" + CreditsText,
        deliveryaddress: "收货地址",
        my_wishes: "我的祝福",
        approve: "认可激励" + CreditsText,
        mine_approve: "我的" + CreditsText,
        thank_approve: "感谢认可",
        record_list: "互赠记录",
        Recognition_incentive:'认可激励',
        I_recognized:'我的认可',
        no_after_sale:'暂时没有售后记录',
        thankWall: "感谢墙",
      },
      Profile: {
        accountinformation: "账户信息",
        basicinformation: "基本信息",
        realname: "真实姓名",
        userID: "用户名",
        company: "公司",
        phoneno: "手机号码",
        changePasswordNow: "立即修改"
      },
      startorder: "立即购买",
      pick_store: "自提",
      express: "快递",
      Mass_securities: "团券",
      user_to_the: "用户自提",
      Courier_delivery: "快递配送",
      Selection_delivery_mode: "选择配送方式",
      delivery_mode_tip1: "您所选商品支持快递物流和用户自提两种配送方式，请从中选择期望的一种配送方式。",
      sell_out: "售罄",
      pick_up_address: "取货地址",
      select_address: "选择地址",
      pick_up_time: "提货时间",
      contact_information: "联系方式",
      Select_person: "选择取件人",
      consignee: "提货人",
      recipient: "取件人",
      Choose_store: "选择自提门店",
      View_point_image: "查看自提点图片",
      business_hours: "营业时间",
      orderNumber: "订单号",
      Retrieving_information: "取货信息",
      consignee_information: "收件信息",
      Check_the_bootstrap: "查看自提码",
      Check_verification_code: "查看核销码",
      To_the_code: "自提码",
      To_the_state: "自提状态",
      To_the_time: "自提时间",
      verification_code: "核销码",
      commodity: "商品",
      State_verification: "核销状态",
      verification_time: "核销时间",
      copy_verification_code: "长按复制核销码",
      copy_from_code: "长按复制自提码",
      For_replenishment: "待补货",
      available: "有货",
      off_the_stocks: "已完成",
      to_cancel_after_verification: "待核销",
      have_cancel_after_verification: "已核销",
      after_verification_failure: "核销失败",
      lost_effectiveness: "已失效",
      verification_tip_con: "温馨提示：请截图保存，以便现场核销",
      Order: {
        orderNo: "订单号",
        picture: "商品图",
        productname: "商品名称",
        specifications: "规格",
        totalprice: "商品总价",
        status: "状态",
        operation: "操作",
        details: "查看详情",
        orderinformation: "订单信息",
        details2: "详细信息",
        shippingfee: "物流费用",
        tax: "税费",
        coupon: "优惠金额",
        creditpoint: "" + CreditsText + "抵扣",
        actualpayment: "实付款",
        paymenttime: "付款时间",
        ordertime: "下单时间",
        productlist: "商品清单",
        productpicture: "商品图",
        price: "价格",
        quantity: "商品数量",
        shippinginformatio: "物流信息",
        checkshippinginformation: "查看物流详情",
        address: "配货地址",
        consignee: "收货人",
        address2: "送货地址",
        contact: "联系电话",
        remarks: "留言备注",
        Pleasefillintheordernotes: "请您填写留言备注",
        shipCompany: "物流公司",
        shipOrderNo: "物流单号",
        noLogisticsInfo: "暂无物流信息",
        deliveryNote: "发货备注",
        previousOrderQueryBtn: "历史订单信息查询 请点击",
        previousOrderQuery: "历史订单信息",
        checkCardPwd: "查看卡密",
        couponDeduction: "优惠券抵扣",
        orderPrice: "订单总价",
        card_number:'卡号',
        password:'密码',
        webpage:'网页',
        mini_program:'小程序',
        To_use_the: "去使用",
        expiration_date: "截止日期",
        siberian_nitraria_fruit: "卡密",
        Extract_the_card_tight: "提取卡密",
        siberian_nitraria_fruit_tip: "*卡密使用方式请仔细阅读商品详情介绍",
        previous_page: "上一页",
        next_page: "下一页",
        close: "关闭",
        No_Order_Data:'当前无订单数据',
        Order_No2: "售后单号",
        Order_Price2: "退货金额",
        Reason2: "退货原因",
        Status2: "售后状态",
        Operation2: "操作",
        Cancel2: "撤销申请",
      },
      succeed: "恭喜您购买成功",
      orderNo: "订单编号",
      amount: "应付金额",
      payment: "支付方式",
      paybycredits: CreditsText + "支付",
      alipay: "支付宝支付",
      Alipay: "支付宝",
      WeChat: "微信",
      WeChatPayment: "微信支付",
      topay: "去支付",
      check: "查看",
      availablePoint: "我的可用" + CreditsText,
      none: "无",
      payNow: "立即支付",
      cancelOrder: "取消订单",
      applyReturn: "申请售后",
      ConfirmReceipt: "确认收货",
      confirmPay: "确定支付",
      afterSale: "售后",
      loginOut: "退出",
      index: "返回首页",
      integral: CreditsText, // 商品列表 积分
      outStockProdTip: "该商品已下架，欢迎挑选其他商品！",
      seckillPrice: "秒杀价",
      originalPrice: "原价",
      creditsDeduction: CreditsText + "抵扣",
      receiveImmediately: "立即领取",
      toUse: "去使用",
      received: "可使用{0}张",
      receivedAgain: "再次领取",
      noCouponTip: "优惠券活动暂未开启!",
      placeWait: "请您耐心等待！",
      noCouponProdTip: "您的公司已经对此类商品进行限制!",
      noCouponProdTip2: "请您查看其他优惠券活动!",
      virtualGoodsTip: "此商品为虚拟物品，下单无法进行退货请提前查看商品详情!",
      buyNow: "立即抢购",
      Sold:'已售',
      timeRemaining: "距离结束",
      seckillEnd: "该秒杀已结束",
      noSeckillTip: "秒杀活动暂未开启！",
      noSpec: "无规格",
      cannotUsed: "不能使用？",
      cannotusedDesc: "无法使用说明",
      confirm_01:
        "在您申请结算的商品中金额未满足用券条件则优惠券无法进行使用。",
      confirm_02: "建议您进入优惠券专区进行凑单！",
      confirm_03_0:
        "您的订单存在未支付订单，当未支付订单完成结算后即可享受减免您未关注公众号不享受减免！",
      close: "关闭",
      change: "修改",
      confirm_03: "收货人身份证验证信息",
      confirm_04: "收货人",
      confirm_05: "身份证号",
      confirm_06:
        "因海关要求，购买信息必须与身份证信息相同！ 需要您进行再次验证信息！",
      sure: "确定",
      Tipstitle: "提示",
      confirm_07: "请删除此商品后再次提交",
      confirm_08: "后跳转到上一页",
      confirm_09: "返回上一页",
      // 收银台
      cashier: "收银台",
      casierSussful: "订单提交成功，请尽快付款！订单号",
      casiertime: "支付剩余时间：",
      casierPlease: "请完成支付，否则订单自动取消，您将无法支付订单！",
      casierneedPay: "订单总金额",
      casierintegral: ordinary + CreditsText,
      casierHoliday: festival + CreditsText,
      casierCredit: "可用额度",
      casiernot: "不可用?",
      casiernotAll: "不能全额抵扣？",
      casierAlso: "还应支付",
      casierOtherpay: "其他支付方式",
      casierWechat: "微信支付",
      casierAliApy: "支付宝支付",
      payNow: "立即支付",
      casier01: "请返回查看您的商品是否通过公司活动等板块进行购买？",
      casier02:CreditsText + "只能定向对公司活动板块商品购买",
      casier03:
        "您在选择商品时，需要注意商品最多能抵扣多少" +
        CreditsText +
        "。根据您购买的商品总额和订单的实际情况。在" +
        CreditsText +
        "支付上我们会自动核算出最高抵扣金额来处理。剩余额度需要您使用第三方支付方式进行支付！",
      casierCancel: "取 消",
      casierSure: "确 定",
      casierPay: "应付金额",
      RMB: "人民币",
      pleaseWechat: "请使用微信扫一扫",
      scanning: "扫描二维码支付",
      flPay: CreditsText + "支付",
      manyNot: CreditsText + "不可用？",
      payCodePage: {
        AccountProtection: "账号保护",
        password: "支付密码",
        sixCode: "请输入六位数字",
        againPass: "再次确认密码",
        again: "再次输入",
        payCodePage01: "为了您的账号安全，请设置支付密码",
        payCodePage02: "密码必须为6位数字",
        payCodePage03: "两次密码输入不一致",
        payCodePage04: "请输入支付密码",
        payCodePage05: "密码确认",
        payCodePage06: "确认订单前，请输入支付密码确认您的身份"
      },
      // 认可激励相关
      approvePage: {
        departemployeeText:'已离职，请先移除！',
        departemployeeTip:'该员工已离职，不可选择哦！',
				selectAll: "全选",
				selectEmployee:'选择员工',
				numberItems:'项目数量',
				effectiveProject:'生效项目',
				invalidProject:'失效项目',
				complimentaryIntegral:'可赠送积分',
				complimentaryCredits:'已赠送积分',
				recoveredIntegral:'已回收积分',
				theProjectManagement:'项目管理',
				pleaseSelectThe:'请选择你要操作的项目',
				currentProjectCredits:'当前项目积分',
				membersOfThe:'成员',
				membersProject:'项目成员',
				selectedQuantity:'已选择数量',
				selectedMember:'已选择成员',
				membersOfTheIncentive:'成员激励',
				giveCardsMembers:'去给你欣赏的项目成员赠送卡片吧',
				immediatelyGive:'立即赠送',
				membersTheManagement:'成员管理',
				manageOrAdd:'去管理或添加你的项目成员',
				managementImmediately:'立即管理',
				subprojects:'子项目',
				projectIncentive:'项目激励',
				creditsToProject:'去给你的项目分配积分吧',
				immediatelyAssigned:'立即分配',
				newSubitem:'新增子项目',
				subprojectsToProject:'去给项目新增子项目',
				immediatelyNew:'立即新增',
				projectBudgetList:'项目预算清单',
				theExportList:'导出清单',
				theRemaining:'剩余',
				hasBeenSent:'已发送',
				distributionThe:'分配方',
				assignedParty:'被分配方',
				operationType:'操作类型',
				operatingState:'操作状态',
				note:'备注',
				projectIntegration:'项目积分',
				ccPeople:'抄送人',
				management:'管理',
				full:'全员',
				add:'添加',
				enterName:'请输入员工姓名',
				determine:'确定',
				complete:'完成',

				projectName:'项目名称',
				enterProjectName:'请输入项目名称',
				projectLeader:'项目负责人',
				enterProjectLeader:'请输入项目负责人',
				parentProject:'父项目',

				incentiveAmount:'激励额度',


				projectSend:'发送',
        thankForWorker: "向同事表示感谢",
        projectThank: "项目感谢",
        selectGift: "选定赠送",
        approvePoints: "认可激励积分",
        detailed: "明细",
        waitPoints: "结算明细",
        thankPoints: "感谢互赠积分",
        personThank: "个人互赠",
        projectRecord: "项目互赠",
        nearThank: "最新收到的感谢",
        more: "更多",
        project: "项目",
        record: "收到",
        thank: "的感谢",
        thankWall: "感谢墙",
        thank_n: "感谢",
        lookOn: "立即围观",
        thankRank: "感谢排行",
        all: "总",
        year: "年",
        quarter: "季",
        month: "月",
        getNum: "获得次数",
        your: "您",
        waitLook: "等等再看",
        lookNow: "前往查看",
        canUsePoints: "可用认可激励积分",
        person: "个人",
        cancel: "取 消",
        sendNow: "立即发送",
        warningPoints: "您当前可用积分不足",
        allReadySend: "已赠送",
        waringForm: "请完善表单信息",
        likeNotes: "点赞说明",
        Incentive_content: "激励内容",
        sendPoints: "赠送积分",
        staff: "员工姓名",
        pleaseInput: "请输入",
        pleaseInputMore: "选定后增加，可多个",
        personThankPoints: "个人互赠积分",
        projectThankPoints: "项目互赠积分",
        time: "时间",
        notes: "说明",
        points: "积分",
        operation: "操作",
        prevPage: "上一页",
        nextPage: "下一页",
        contain: "包含",
        messageShield: "信息已屏蔽",
        alreadyRecord: "已收到",
        send: "赠送",
        lookDetails: "查看详情",
        noCard: "暂无感谢卡",
        noThank: "暂无感谢",
        noThankRank: "暂无感谢排行",
        noThankGet: "暂未收到感谢卡",
        monthRank: "月度排行",
        personRank: "个人排行榜",
        projectRank: "项目排行榜",
        monthName: "姓名",
        monthDepartment: "部门",
        monthJobnumer: "工号",
        monthGetNum: "获得次数",
				obtainIntegral: "获得积分",

        AvailableCredits:'可赠送积分',
        AvailableCredits_tip:'个人账户收到的公司直接分配给个人的激励积分总和。',
        UnsettledCredits:'待结算积分',
        UnsettledCredits_tip:'个人账户收到的个人赠送和项目赠送的激励积分总和，待计算积分结算为普通积分后才可以去消费。',
        SettledCredits:'已结算积分',
        FixedMode:'个人感谢卡固定积分',
        CustomMode:'个人感谢卡无限制积分',
        FreeMode:'个人感谢无积分',
        SettledCredits_tip:'个人账户里面收到的激励积分已结算为普通积分的积分总和。',
        Manage_operationally:'对您的项目进行操作管理吧',
        AdmireColleague:'您欣赏TA的',
        AdmireColleague_tip:'选择卡片赠送给同事',
        Received:'您收到的',
        Presented:'您赠送的',
        RankingList:'感谢排行',
        Credits:'积分',
        amount:'次数',
        Download:'下载PDF',
        remarks:'备注',
        pleaseSelect: "请选择",
      },
      blessing: {//送祝福相关
        received:'已收到',//已收到
        presented:'已赠送',//已赠送
        No_record:'暂无记录！',//
      },
      refund: {
        order: "订单",
        Apply_after_sales: "申请售后",
        detailed_information: "详细信息",
        After_sales_order: "售后订单",
        After_the_details: "售后详情",
        title: "申请退货",
        Commodity_figure: "商品图",
        product_name: "商品名称",
        specs: "规格",
        ReturnReason: "退货原因",
        reason: "请描述售后原因",
        Upload: "上传凭证",
        submit: "提交",
        orderNumber: "订单号",
        order_status: "订单状态",
        After_single_number: "售后单号",
        The_order_number: "订单单号",
        time_application: "申请时间",
        refundAmount: "退款金额",
        logistics_fees: "物流费用",
        order_time: "下单时间",
        integral: CreditsText,
        partyAmount: "第三方支付",
        uploadDocuments: "上传凭证",
        please_select:'请选择',
        After_sales_amount:'售后金额',
        Integral_to_pay:CreditsText + '支付',
        After_sale_way:'售后方式',
        Whether_the_goods:'是否收货',
        Product_return_method:'商品返还方式',
        After_why:'售后原因',
        Termination_the_note:'终止备注',
        description_and_credentials:'补充描述和凭证',
        max_5:'最多五张',
        contactService: "联系客服",
        LogisticsInfo: "录入物流信息",
        submitApplications: "提交申请",
        cancel: "取消",
        goodsToDetermine: "商品判定",
        accomplish: "完成",
        commodityInformation: "商品信息",
        refundNumber: "退款单号",
        refundTime: "退款时间",
        refundWay: "退款方式",
        third_party_payment:'第三方支付',
        weixin: "微信",
        negotiationSituation: "协商情况",
        cancelAfter_sale: "取消售后",
        reapply: "再次申请",
        refund_number:'退款单号',
        refund_of_time:'退款时间',
        refund_way:'退款方式',
        After_describing:'售后描述',
        After_credentials:'售后凭证',
        Supplier_receiving_information:'供应商收货信息',
        Mailing_contact:'邮寄联系人',
        contact_number:'联系人电话',
        mailing_address:'邮寄地址',
        address_coding:'地址编码',
        mailing_information:'邮寄信息',
        logistics_company:'物流公司',
        courier_number:'快递单号',
        Goods_return_receiving_information:'货品返还接收信息',
        edit:'编辑',
        submit_information:'提交资料',
        contacts:'联系人',
        detailed_address:'详细地址',
        please_enter:'请输入',
        Fill_return_information: "填写寄回信息",
        Need_arrange_delivery: "需要安排送货",
        Waiting_for_pickup: "等待上门取件",
      },

    };
  },
  languageChangeEn(state) {
    let enCreditsText = "";
    if (window.sessionStorage.getItem("MODULEDATA")) {
      enCreditsText =
        JSON.parse(window.sessionStorage.getItem("MODULEDATA")).creditNameEn ||
        "Credits";
    }
    let companyName = "fuli";
    if (process.env.COMPANY_NAME == "fenghuo") {
      companyName = "zhenxiaoVIP";
    } else if (process.env.COMPANY_NAME == "mz") {
      companyName = "minzhishangcheng";
    }
    /***
         * 星展银行特殊处理
         * aon积分名称修改“iFlex积分” 英文“iFlex points”
           节日积分名称修改为员工俱乐部积分，英文“Club points”
          * ***/
    let aon = "iFlex ";
    let festival = "Festival ";
    let ordinary = "Ordinary ";
    let iFlex = JSON.parse(sessionStorage.getItem("MODULEDATA"))
      ? JSON.parse(sessionStorage.getItem("MODULEDATA")).iFlex
      : "";
    if (iFlex) {
      aon = "iFlex";
      festival = "Club";
      ordinary = "Other  ";
    }
    state.messageEn.message = {
      ordinary: ordinary,
      festival: festival,
      discounts2: "Discount",
      price_range: "Price Range",
      purchase_notes: "Purchase Notes",
      FrequentlyAskedQuestions_weini:
        "Frequently asked questions on cross-border goods",
      confirm_order_tip1:
        'Because the address information is adjusted, please edit the "region" option in the current delivery address again, and you can place the order smoothly!',
      confirm_order_btn1: "To perfect",
      FrequentlyAskedQuestions: "common Questions",
      FrequentlyAskedQuestions_weini:
        "Frequently asked questions on cross-border goods",
      weiNiInternational: "Vinie supply chain",
      integralBuckle: enCreditsText + " can be low",
      paymentQuestion: "Payment Question", //支付疑问
      containsFees: "Contains the taxes and fees",
      troubleShooting: "trouble shooting",
      shipAddress: "place of dispatch",
      paymentQuestionTitle1: "mode of despatch",
      paymentQuestionTitle2: "expenses of taxation",
      paymentQuestionTitle3: "Part of the deduction",
      paymentQuestionCon1:
        "Cross-border goods shipped through overseas or bonded warehouses will be divided into bonded warehouses at different gateways according to different conditions of the goods.The timeliness of receiving goods will also be different",
      paymentQuestionCon2:
        "The purchase of overseas goods shall be declared and taxed to the Chinese customs in accordance with the law",
      paymentQuestionCon3:
        "Cross-border goods are supplied by a variety of suppliers, some of which are shipped directly from overseas warehouses, according to the customs declaration conditions of China.The payment slip, logistics slip and order number information (commodities, payment amount and other information) must be declared through the customs.",
      paymentQuestionCon4:
        "If you encounter some goods can only deduct part of the amount, please understand the inconvenience brought to you!",
      attention_tip1: "Pay attention to the public number to buy goods again",
      attention_tip2: "follow the Wechat official account",
      attention_tip3: "You have followed the public account",
      attention_tip4: "This order is deductible",
      attention_tip5: "Unsubscribe will no longer be eligible！",
      pay_attention_to: "Pay attention to",
      money_z: "￥",
      focus_on_relief: "Focus on relief",
      has_been_cut: "Has been cut",
      attention_tip6: "Commodity purchase province",
      attention_tip7: "Purchase goods expected to save",
      attention_tip8:
        "WeChat scan qr code to follow the public, this product can be immediately reduced",
      info_tip3:
        "· does not support 7 days without reason to return or replace goods · id card verification · cash payment",
      shopCart01: "The item you selected contains international items",
      shopCart02: "Need to be settled separately from other goods",
      shopCart03: "Vinie supply chain",
      yourCart: "Your Cart",
      checkTheCart: "Add the Cart",
      checkOrderInfo: "Fill in and check the Information",
      placeTheOrder: "Place the Order",
      selectAll: "Select All",
      product: "Product",
      specification: "Specification",
      price: "Price",
      quantity: "Quantity",
      ExtPrice: "Ext. Price",
      ExtPrice2: "Ext. Price",
      noGoods: "no goods in this area",
      pleaseChoose: "Please choose",
      state: "State",
      stock: "Stock",
      operation: "Operation",
      delete: "Delete",
      total: "Total",
      proceedToOrder: "Buy now",
      contactInfo: "Contact Info",
      addYourAddressFirst: "Add your contact address",
      addAnAddress: "Add an Address",
      Create_address:'Create Address',
      address:'Address',
      addressInfo:{
        Edit:'Edit',
        Delete:'Delete',
        Address:'Address',
        Name:'Name',
        Phone:'Phone',
        Default:'Default',
      },
      checkTheOrder: "Check The Order",
      PricesForCustom: "Prices For Custom",
      discounts: "Discount",
      points: enCreditsText,
      YourCurrentPoint: "your current Credits are",
      YourCurrentPoint2: "",
      youCouldUse: "you could use ",
      thisTime: "this time",
      coupons: "coupons",
      available: "available",
      noUsingOfCoupons: "no using of coupons",
      delivery: "Delivery Fee",
      freight: "Freight",
      oldpassword: "old password",
      newpassword: "new password",
      repnewpassword: "rep new password",
      support: "Support",
      paymentMethod: "Payment Method",
      youHaveToPay: "you have to pay",
      orderInfo: "Order Info",
      productsPrice: "Products",
      freightPrice: "Freight",
      discountsPrice: "discounts",
      proceedToOrder2: "Buy now",
      price2: "Price",
      fuli: "Price",
      distributionTo: "Distribution",
      inStock: "In Stock",
      outStock: "Out Stock",
      pts: enCreditsText,
      quantity2: "Quantity",
      addToCart: "Add to cart",
      productIsSoldOut: "Goods out of stock",
      productInfo: "Product Info",
      afterSalesService: "After Sales Service",
      hello: "Hello",
      yourCurrentPo: "，",
      hdPoint: "",
      yourOrders: "My Orders",
      approve: "Recognition",
      yourAccount: "My Account",
      welcome: "Welcome",
      benefitModules: "Benefit Modules",
      accountManagement: "Account Management",
      changePassword: "Password",
      changePassword2: "Change Password",
      NewPassword:'New Password',
      OldPassword:'Old Password',
      Re_NewPassword:'Re-enter New Password',
      close: "close",
      PaymentManagement: "Payment Management",
      changepaypassword: "change pay password",
      password: "password",
      customer: "Customer",
      IntegralInfo: enCreditsText,
      Ques: {
        OrderingGuide: "Ordering Guide",
        MemberAccount: "Member Account",
        OrderMethods: "Order Methods",
        PaymentTerms: "Payment Terms",
        ReturnsReplacements: "Returns & Replacements",
        CarrierInformation: "Carrier Information",
        PaymentDelivery: "Payment & Delivery",
        PaymentMethods: "Payment Methods",
        DeliveryTimes: "Delivery Times",
        DeliveryAreas: "Delivery Areas",
        CheckSign: "Check & Sign",
        CustomerCenter: "Customer Center",
        TermsofUse: "Terms of Use",
        RulesofPoints: "Rules of " + enCreditsText,
        GuaranteePolicy: "Guarantee Policy",
        InformationProtection: "Information Protection",
        AboutUs: "About Us",
        Clients: "Clients",
        LegalNotice: "Legal Notice",
        ContactUs: "Contact Us"
      },
      fuliCo: "©Fuli Co., Ltd 2013-2020 All Rights Reserved",
      Screening: "Screen",
      PriceLow: "Price: Low to High",
      PriceHigh: "Price: High to Low",
      SaleLow: "Sales Volume: Low to High",
      SaleHigh: "Sales Volume: High to Low",
      NewArrival: "New Arrivals",
      Category: "Category",
      Help: "Help",
      CompanyIntro: "Company Introduce",
      specialRecommend: "special recommend",
      Discounts: "Discount",
      Search: "Search",
      LowPrice: "Low Price",
      WorryfreeAftersalesService: "Worry-free After-sales Service",
      QualityGuarantee: "Quality Guarantee",
      StandardCredits: "Standard " + enCreditsText,
      FestivalCredits: festival + " " + enCreditsText,
      aonCredits: "" + aon + " " + " " + "Credits",
      No_detail:'No details on cooperation platform',
      aonCreditsNo: "" + aon + "  " + enCreditsText + " has no details",
      aonCreditsText: "Cooperation platform integral is the integration of the platform integral data, real-time consumption data please log in the cooperation platform for viewing!",//合作平台积分为对接的合作平台积分数据，实时消耗数据请登录合作平台进行查看！
      creditsChane: "The " + enCreditsText + " can be selected for deduction",
      fixNav: {
        Coupon: "Coupon",
        Cart: "Cart",
        Credits: enCreditsText == "Credits" ? "Credits" : enCreditsText,
        Orders: "Orders",
        applet: "Wechat Program",
        QRCode: "QR Code",
        Tencent: "Official Account",
        scanQRCode: "Scan QR Code",
        followthewechatofficialaccount: "Follow the wechat official account",
        onlinecustomerservice: "Online Customer Service",
        onlinetime: "Online Time",
        customerservice: "Customer Service",
        contactcustomerservice: "Contact Customer Service",
        callcenter: "Hotline",
        workingday: "working day",
        yourID: "Your ID/Company ID",
        pleasefeedbacktothecustomerservicepeople:
          "Please feedback to the customer service people",
        top: "Top"
      },
      newaddress: "Add Address",
      newaddress2: "Please complete the delivery address and start your shopping trip",//请完善收货地址，开启购物之旅
      editAddress: "Edit Address",
      addressinformation: "Address Information",
      Townshipstreet: "Township Street",
      addressdetail: "Address Detail",
      consigneename: "Consignee Name",
      phoneNo: "Phone No",
      identitycard: "Identity Card",
      defaultaddress: "Default Address",
      Address_area: "Address Area",//地址区域
      Overseas_address: "Overseas Address",//海外地址
      Overseas_address_remark: "Goods delivered overseas only",//仅限境外配送商品
      Chinese: "Chinese",
      English: "English",
      save: "Save",
      cancel: "Cancel",
      confirm:'Confirm',
      More:'More',
      suggest: {
        construction_content: "construction content",
        suggested_type: "Suggested that type",
        status: "status",
        see_feedback: "See the feedback",
        have_acccepted: "have acccepted",
        being_processed: "being processed",
        complaints_immediately: "Immediate Complaint Suggestion",
        reply_content: "Reply Content",
        upload_pictures: "Upload Pictures",
        suggest_tip1:
          "The recommended size is 350*120 and only JPG/PNG/BMP files can be uploaded, and a single file should not exceed 3M",
        suggest_tip2:
          "Every feedback from you is a powerful support to us!Thank you for your participation!",
        submissions: "Submissions",
        complaints_time: "Complaints of time",
        complaint_category: "The complaint category",
        complaint_content: "complaint content",
        documentary_evidence: "documentary evidence",
        advice_feedback: "Advice feedback",
        suggest_tip3:
          "We have received your Suggestions, and we will send you the relevant questions and contents as soon as possible.Thank you for your support!",
        goBack: "go back"
      },
      MY: {
        myaccount: "My Account",
        ordercenter: "Order Center",
        myorders: "My Orders",
        customercenter: "Customer Center",
        complaint_advice: "Complaint and Advice",
        mydiscountcoupon: "My Discount Coupon",
        myaftersalesservice: "My After-sales Service",
        myElectronicCard: "My Electronic Card",
        accountcenter: "Account Center",
        mycredits: "My " + enCreditsText,
        deliveryaddress: "Delivery Address",
        my_wishes: "My Wishes",
        approve: "Approve" + enCreditsText,
        mine_approve: "My approve" + enCreditsText,
        thank_approve: "Thank Approve",
        record_list: "Giving Records",
        Recognition_incentive:'Recognition Incentive',
        I_recognized:'My Recognition',
        no_after_sale:'No After-sales Record',
        thankWall: "Thank Wall",
      },
      Profile: {
        accountinformation: "Account Information",
        basicinformation: "Basic Information",
        realname: "Real Name",
        userID: "USER ID",
        company: "Company",
        phoneno: "Phone No.",
        changePasswordNow: "Change Password Now"
      },
      startorder: "Buy now",
      Courier_delivery: "Courier delivery",//快递配送
      pick_store: "Pick up in a store", //自提
      express: "Express", //快递
      Mass_securities: "Mass of stamps",//团劵
      user_to_the: "The user to the",//用户自提
      Selection_delivery_mode: "Selection of delivery mode",//选择配送方式
      delivery_mode_tip1: "The goods you selected can be delivered by express delivery and user's own delivery. Please choose one of them.",//您所选商品支持快递物流和用户自提两种配送方式，请从中选择期望的一种配送方式。
      sell_out: "sell out",
      pick_up_address: "Pick up address",//取货地址
      select_address: "Select address",//选择地址
      pick_up_time: "Pick-up time",//提货时间
      contact_information: "Contact information",//联系方式
      consignee: "Consignee",//提货人
      Select_person: "Select the pick-up person",//选择取件人
      recipient: "Recipient",//取件人
      Choose_store: "Choose a pickup store", //选择自提门店
      View_point_image: "View the self - lift point image", //查看自提点图片
      business_hours: "Business hours", //营业时间
      orderNumber: "Order Number",
      Retrieving_information: "Retrieving information",//取货信息
      consignee_information: "Consignee Information",//收件信息
      Check_the_bootstrap: "Check the bootstrap",//查看自提码
      Check_verification_code: "Check the verification code",//查看核销码
      To_the_code: "To the code",//自提码
      To_the_state: "To the state",//自提状态
      To_the_time: "To the time",//自提时间
      verification_code: "The verification code",//核销码
      commodity: "Commodity",//商品
      State_verification: "State of cancel after verification",//核销状态
      verification_time: "Cancel after verification time",//核销时间
      copy_verification_code: "Long press copy verification code",//长按复制核销码
      copy_from_code: "Long press copy from the code",//长按复制自提码
      For_replenishment: "For replenishment", //待补货
      available: "Available", //有货
      off_the_stocks: "off the stocks", //已完成
      to_cancel_after_verification: "To cancel after verification", //待核销
      have_cancel_after_verification: "Have cancel after verification", //已核销
      after_verification_failure: "Cancel after verification failure", //核销失败
      lost_effectiveness: "lost effectiveness", //已失效
      verification_tip_con: "Tips: Please save screenshots for verification on site", //温馨提示：请截图保存，以便现场核销
      Order: {
        orderNo: "Order No.",
        picture: "Picture",
        productname: "Product Name",
        specifications: "Specifications",
        totalprice: "Total Price",
        status: "Status",
        operation: "Operation",
        details: "Details",
        orderinformation: "Order Information",
        details2: "Details",
        shippingfee: "Shipping Fee",
        tax: "tax",
        coupon: "coupon",
        creditpoint: enCreditsText + " Credits",
        actualpayment: "Actual Payment",
        paymenttime: "payment time",
        ordertime: "Order Time",
        productlist: "Product List",
        productpicture: "Product Picture",
        price: "Price",
        quantity: "Quantity",
        shippinginformatio: "Shipping Informatio",
        checkshippinginformation: "Check Shipping Information",
        address: "Address",
        consignee: "Consignee",
        address2: "Address",
        contact: "Contact",
        remarks: "Remarks",
        Pleasefillintheordernotes: "Please fill in the order notes",
        shipCompany: "Logistics company",
        shipOrderNo: "Express number",
        noLogisticsInfo: "No logistics information",
        deliveryNote: "Delivery Note",
        previousOrderQueryBtn: "Previous order query search,please click",
        previousOrderQuery: "Previous Order Query",
        checkCardPwd: "View card password",
        couponDeduction: "coupon deduction",
        orderPrice: "Order Price",
        card_number:'Card number',
        password:'Password',
        webpage:'Webpage',
        mini_program:'mini program',
        To_use_the: "To use the",
        expiration_date: "expiration date",
        siberian_nitraria_fruit: "siberian nitraria fruit",
        Extract_the_card_tight: "Extract the card tight",
        siberian_nitraria_fruit_tip: "*Please read the product details carefully",
        previous_page: "Previous",
        next_page: "Next",
        close: "Close",
        No_Order_Data:'No Order Data',
        Order_No2: "Order No",//售后单号
        Order_Price2: "Order Price",//退货金额
        Reason2: "Reason",//退货原因
        Status2: "Status",//售后状态
        Operation2: "Operation",//操作
        Cancel2: "Cancel",//撤销申请
      },
      succeed: "succeed",
      orderNo: "order No.",
      amount: "amount",
      payment: "payment",
      paybycredits: "paybycredits",
      alipay: "Alipay",
      Alipay: "Alipay",
      WeChat: "WeChat",
      WeChatPayment: "WeChat Pay",
      topay: "To Pay",
      check: "check",
      availablePoint: "Available",
      none: "none",
      payNow: "Pay",
      cancelOrder: "Cancel",
      applyReturn: "Apply return",
      ConfirmReceipt: "Confirm receipt",
      confirmPay: "Confirm pay",
      afterSale: "After sale",
      loginOut: "Login Out",
      index: "Home Page",
      integral: enCreditsText,
      outStockProdTip:
        "The goods has been off the shelves, please choose other goods!",
      seckillPrice: "Seckill Price",
      originalPrice: "Original Price",
      creditsDeduction: enCreditsText + " Deduction",
      receiveImmediately: "Receive Immediately",
      toUse: "To Use",
      received: "can use {0}",
      receivedAgain: "Received Again",
      noCouponTip: "Coupons activities are not open!",
      placeWait: "Please wait patiently",
      noCouponProdTip: "Your company has been to limit such goods!",
      noCouponProdTip2: "Would you please check other coupons activities!",
      virtualGoodsTip:
        "This product is a virtual good,can not be returned,please check the details of the product.",
      buyNow: "Buy now",
      Sold:'Sold',
      timeRemaining: "Remaining time",
      seckillEnd: "The SEC has ended",
      noSeckillTip: "Seckill activities are not open!",
      noSpec: "no Spec",
      cannotUsed: "Can't Used?",
      cannotusedDesc: "cant used desc",
      confirm_01:
        "The coupon cannot be used if the amount of the goods you apply for settlement does not meet the conditions for using the coupon.",
      confirm_02:
        "It is recommended that you enter the coupon area to make a list!",
      confirm_03_0:
        "There is an unpaid order in your order, you can enjoy the deduction after the completion of the settlement of the unpaid order.",
      close: "close",
      change: "change",
      confirm_03: "Consignee ID verification information",
      confirm_04: "Consignee",
      confirm_05: "ID Number",
      confirm_06:
        "As required by the customs, the purchase information must be the same as the ID card information! You need to verify the information again!",
      sure: "sure",
      Tipstitle: "Tips",
      confirm_07: "Please delete this item and submit again",
      confirm_08: "Go back to previous page",
      confirm_09: "Back to previous page",
      // 收银台
      cashier: "Cashier",
      casierSussful:
        "Order submitted successfully, please pay as soon as possible! Order number",
      casiertime: "Remaining time of payment:",
      casierPlease:
        "Please complete the payment, otherwise the order will be cancelled automatically!",
      casierneedPay: "Total pay",
      casierintegral: ordinary + enCreditsText,
      casierHoliday: festival + " " + enCreditsText,
      casierCredit: "Credit",
      casiernot: "not used ?",
      casiernotAll: "not used All",
      casierAlso: "Also pay",
      casierOtherpay: "Other payment method ",
      casierWechat: "Wechat Pay",
      casierAliApy: "Alipay",
      payNow: "Pay now",
      casier01: "Please return to see if your products are purchased through festivals and other activities?",
      casier02: "Festival credits can only be purchased for festival products",
      casier03:
        "When you select a product, you need to pay attention to the maximum " +
        enCreditsText +
        " that can be deducted from the product. According to the total amount of goods you purchased and the actual situation of the order. We will automatically calculate the maximum deductible amount in the " +
        enCreditsText +
        " payment. You need to use the third-party payment method to pay the remaining amount!",
      casierCancel: "cancel",
      casierSure: "sure",
      casierPay: "Pay",
      RMB: "RMB",
      pleaseWechat: "Wechat Scanning",
      scanning: " Pay",
      flPay: enCreditsText + " pay",
      manyNot:enCreditsText + " can not be available？",
      payCodePage: {
        AccountProtection: "Account Pro",
        password: "password",
        sixCode: "six number",
        againPass: "again Pass",
        again: "again",
        payCodePage01: "please set code",
        payCodePage02: "six number",
        payCodePage03: "Two password entries are inconsistent",
        payCodePage04: "Please enter the payment password",
        payCodePage05: "password sure",
        payCodePage06:
          "Before confirming the order, please enter the payment password to confirm your identity"
      },
      // 认可激励相关
      approvePage: {
        departemployeeText:' has resignated, please remove first!',
        departemployeeTip:'The employee has resigned and cannot be selected!',
				selectAll: "Select All",
				selectEmployee:'Select the employee',
				numberItems:'Projects',
				effectiveProject:'Effective Project',
				invalidProject:'Expired Projects',
				complimentaryIntegral:'Available Credits',
				complimentaryCredits:'Presented Credits',
				recoveredIntegral:'Reclaimed Credits',
				theProjectManagement:'Project Manage',
				pleaseSelectThe:'Select Project',
				currentProjectCredits:'Project Credits',
				membersOfThe:'Members',
				membersProject:'Members',
				selectedQuantity:'Selected quantity',
				selectedMember:'Selected member',
				membersOfTheIncentive:'Member Recognition',
				giveCardsMembers:'Select card to give to members',
				immediatelyGive:'Send Now',
				membersTheManagement:'Member Manage',
				manageOrAdd:'Add and remove members of team',
				managementImmediately:'Operate Now',
				subprojects:'Sub Projects',
				projectIncentive:'Project Recognition',
				creditsToProject:'Select card to give to subproject',
				immediatelyAssigned:'Send Now',
				newSubitem:'Add Subprojects',
				subprojectsToProject:'Add subproject to project',
				immediatelyNew:'Operate Now',
				projectBudgetList:'Project Details List',
				theExportList:'Export',
				theRemaining:'Available',
				hasBeenSent:'Presented',

				distributionThe:'Giver',
				assignedParty:'Recipient',
				operationType:'Operation type',
				operatingState:'Operation Status',
				note:'P.S.',
				projectIntegration:'Available Credis',
				ccPeople:'CC',
				management:'Members',
				full:'all',
				add:'add',
				enterName:'Please enter employee name',
				determine:'Confirm',
				complete:'complete',
				projectName:'Project Name',
				enterProjectName:'Please enter a project name',
				projectLeader:'Project Owner',
				enterProjectLeader:'Please enter the project leader',
				parentProject:'Parent Project',
				incentiveAmount:'Credits',

				projectSend:'send',
        thankForWorker: "Thank For Worker",
        projectThank: "Project Thank",
        selectGift: "Select Gift",
        approvePoints: "Approve Credits",
        detailed: "detailed",
        waitPoints: "Credits Details",
        thankPoints: "Thank Credits",
        personThank: "person",
        projectRecord: "project",
        nearThank: "Near Thank",
        more: "More",
        project: "Project",
        record: "Record",
        thank: "'s thank",
        thankWall: "Thank Wall",
        thank_n: "thank",
        lookOn: "Detail",
        thankRank: "Rank",
        all: "all",
        year: "year",
        quarter: "quarter",
        month: "month",
        getNum: "number",
        your: "you",
        waitLook: "Wait Look",
        lookNow: "Look Now",
        canUsePoints: "Available Credits",
        person: "person",
        cancel: "Cancel",
        sendNow: "Send",
        warningPoints: "You don't have enough Credits at present",
        allReadySend: "Presented",
        waringForm: "Please complete the form information",
        likeNotes: "Like Notes",
        Incentive_content: "P.S.",//激励内容
        sendPoints: "Credits",
        staff: "Name",
        pleaseInput: "Please Input",
        pleaseInputMore: "please select one or more",
        personThankPoints: "Person Thank Credits",
        projectThankPoints: "Project Thank Credits",
        time: "Time",
        notes: "Notes",
        points: "Credits",
        operation: "Operation",
        prevPage: "Previous",
        nextPage: "Next",
        contain: "contain",
        messageShield: "Message Shield",
        alreadyRecord: "Received",
        send: "Send",
        lookDetails: "details",
        noCard: "No Card",
        noThank: "No Thank",
        noThankRank: "No Thank Rank",
        noThankGet: "No Thank Get",
        monthRank: "Month Rank",
        personRank: "Person Rank",
        projectRank: "Project Rank",
        monthName: "Name",
        monthDepartment: "Department",
        monthJobnumer: "Job Numer",
        monthGetNum: "Get Numer",
				obtainIntegral: "To obtain the integral",

        AvailableCredits:'Available Credits',//可赠送积分
        AvailableCredits_tip:'The total credits allocated by company',//个人账户收到的公司直接分配给个人的激励积分总和。
        UnsettledCredits:'Unsettled Credits',//待结算积分
        UnsettledCredits_tip:'The unsettled credits sended by colleague and team.',//个人账户收到的个人赠送和项目赠送的激励积分总和，待计算积分结算为普通积分后才可以去消费。
        SettledCredits:'Settled Credits',//已结算积分
        FixedMode:'Fixed Mode',//个人感谢卡固定积分
        CustomMode:'Custom Mode',//个人感谢卡无限制积分
        FreeMode:'Free Mode',//个人感谢无积分
        SettledCredits_tip:'The settled credits sended by colleague and team.',//个人账户里面收到的激励积分已结算为普通积分的积分总和。
        Manage_operationally:'Manage your projects operationally',//对您的项目进行操作管理吧
        AdmireColleague:'Admire Colleague',//您欣赏TA的
        AdmireColleague_tip:'Select card to give to colleagues',//选择卡片赠送给同事
        Received:'Received',//您收到的
        Presented:'Presented',//您赠送的
        RankingList:'Ranking List',//感谢排行
        Credits:'Credits',
        amount:'Amount',
        Download:'Download',//下载PDF
        remarks:'remarks',//备注
        pleaseSelect: "please select",//请选择
      },
      blessing: {//送祝福相关
        received:'received',//已收到
        presented:'presented',//已赠送
        No_record:'No record！',//暂无记录
        RankingList:'Ranking List',//感谢排行
      },
      refund: {
        order: "Order",//订单
        Apply_after_sales: "Apply for after sales",//申请售后
        detailed_information: "detailed information",//详细信息
        After_sales_order: "After sales order",//售后订单
        After_the_details: "After the details",//售后详情
        title: "refund",
        Commodity_figure: "Commodity figure",//商品图
        product_name: "product name",//商品名称
        specs: "specs",//规格
        ReturnReason: "Return reason",
        reason: "Please describe the after-sales reason",
        Upload: "Upload",
        submit: "submit",
        orderNumber: "order number",
        order_status: "order status",//订单状态
        After_single_number: "After a single number",//售后单号
        The_order_number: "The order number",//订单单号
        time_application: "time of application",//申请时间
        refundAmount: "refund amount",
        logistics_fees: "logistics fees",//物流费用
        order_time: "order time",//下单时间
        integral: enCreditsText,
        partyAmount: "other payment",
        uploadDocuments: "upload documents",
        please_select:'please select',
        After_sales_amount:'After sales amount',//售后金额
        Integral_to_pay:enCreditsText + ' to pay',//积分支付
        After_sale_way:'After-sale way',//售后方式
        Whether_the_goods:'Whether the goods',//是否收货
        Product_return_method:'Product return method',//商品返还方式
        After_why:'After why',//售后原因
        Termination_the_note:'Termination of the note',//终止备注
        description_and_credentials:'Supplementary description and credentials',//补充描述和凭证
        max_5:'max 5',//最多五张
        contactService: "Customer",
        LogisticsInfo: "Logistics Info",
        submitApplications: "submit applications",
        cancel: "cancel",
        goodsToDetermine: "goods to determine",
        accomplish: "accomplish",
        commodityInformation: "commodity information",
        refundNumber: "refund number",
        refundTime: "refund of time",
        refundWay: "refund way",
        third_party_payment:'third party payment',//第三方支付
        weixin: "weixin",
        negotiationSituation: "Negotiation situation",
        cancelAfter_sale: "Cancel the after-sale",
        reapply: "reapply",
        refund_number:'refund number',//退款单号
        refund_of_time:'refund of time',//退款时间
        refund_way:'refund way',//退款方式
        After_describing:'After describing',//售后描述
        After_credentials:'After credentials',//售后凭证
        Supplier_receiving_information:'Supplier receiving information',//供应商收货信息
        Mailing_contact:'Mailing contact',//邮寄联系人
        contact_number:'contact number',//联系人电话
        mailing_address:'mailing address',//邮寄地址
        address_coding:'address coding',//地址编码
        mailing_information:'mailing information',//邮寄信息
        logistics_company:'logistics company',//物流公司
        courier_number:'courier number',//快递单号
        Goods_return_receiving_information:'Goods return receiving information',//货品返还接收信息
        edit:'edit',//编辑
        submit_information:'submit information',//提交资料
        contacts:'contacts',//联系人
        detailed_address:'detailed address',//详细地址
        please_enter:'please enter',//请输入
        Fill_return_information: "Fill in the return information",//填写寄回信息
        Need_arrange_delivery: "Need to arrange delivery",//需要安排送货
        Waiting_for_pickup: "Waiting for pickup",//等待上门取件
      },
    };
  },
  changeConfigAuth(state, val) {
    // state.configAuth.bothBottom = 'aaaa'
    // return false
    // Array.forEach((item, index) => {
    //     state.configAuth[item] = 'aaaa'
    // })
  },
  urlPathChange(state, val) {
    state.urlPath = val;
  }
  /*[SET_BANNER_IMGS](state, payload) {
        state.banner = payload;
    }*/
};



// WEBPACK FOOTER //
// ./src/store/mutations.js